import React from 'react';
import { Heading, Paragraph, UnorderedList } from '@massds/mayflower-react';

const NoResults = (props) => {
  const { query } = props;
  const noResultsMessage = `We did not find results for "<strong>${query}</strong>."`;
  const helpText = {
    sublist: [
      { text: 'Check your spelling' },
      { text: 'Try a more generic search term' }
    ]
  };
  return(
    (query && query.length > 0) && (
      <React.Fragment>
        <Heading text="No results found" level={3} />
        <Paragraph text={noResultsMessage} />
        <Paragraph text="Here are a few search tips: " />
        <UnorderedList {...helpText} />
      </React.Fragment>
    )
  );
};
export default NoResults;
